import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormControl, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateLearningGrowthView } from '../../../../../../store/actions/class-marking.actions'
import { currentMarking, initialMarking, stepMarking } from '../../../../../card/LearningGrowth/Styles'

const LegendLearningGrowth = ({ top = 250 }) => {
  const width = 28
  const dispatch = useDispatch()
  const view = useSelector((state) => state?.classMarking?.learningGrowthView)
  const options = [
    {
      label: 'Columns',
      value: 'column'
    },
    {
      label: 'Rows',
      value: 'row'
    }
  ]

  return (
    <div
      className={['bg-background bottom-0 absolute z-20 overflow-auto border-t border-muted']}
      style={{ top: `calc(${top}px + 2rem)`, width: 'calc(200px - 0.5rem)' }}
    >
      <div
        className='bg-background  border-b border-muted flex items-center justify-center'
        style={{
          height: 50,
          width: 'calc(200px - 0.5rem)'
        }}
      >
        <FormControl variant='outlined' fullWidth className=' bg-background rounded'>
          <Select
            variant='outlined'
            value={view}
            onChange={(e) => dispatch(updateLearningGrowthView(e.target.value))}
            size='small'
          >
            {options?.map((op) => (
              <MenuItem key={`selector-view-${op.value}`} value={op.value}>
                {op.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className='pt-4 pb-2 pl-1 pr-2 flex flex-col gap-2 text-muted-foreground'>
        <div className='flex items-center gap-2 h-10'>
          <div style={{ width, height: width }} className='flex items-center justify-center rounded-full'>
            <div
              style={{
                borderBottom: `3px dashed var(--muted-foreground)`,
                width
              }}
            />
          </div>
          <Typography
            className='text-muted-foreground text-sm absolute'
            style={{ left: `calc(${width}px + 0.5rem)` }}
          >
            Path
          </Typography>
        </div>
        <div className='flex items-center gap-2 h-10'>
          <div style={{ width, height: width }} className=' flex items-center justify-center rounded-full'>
            <FontAwesomeIcon icon={initialMarking} size='2xl' />
          </div>
          <Typography className='text-muted-foreground text-sm'>Starting Level</Typography>
        </div>
        {/* <div className='flex items-center gap-2 h-10'>
          <div style={{ width, height: width }} className=' flex items-center justify-center rounded-full'>
            <FontAwesomeIcon icon={stepMarking} size='2xl' />
          </div>
          <Typography className='text-muted-foreground text-sm'>Step</Typography>
        </div> */}
        <div className='flex items-center gap-2 h-10'>
          <div style={{ width, height: width }} className=' flex items-center justify-center rounded-full'>
            <FontAwesomeIcon icon={currentMarking} size='2xl' />
          </div>
          <Typography className='text-muted-foreground text-sm'>Current Level</Typography>
        </div>
      </div>
    </div>
  )
}

export default LegendLearningGrowth
